const loadingStates = {
  base: 'base',
  pending: 'fetching',
  success: 'success',
  failed: 'failed',
};

export default loadingStates;
